var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "d-flex justify-content-center",
    },
    [
      _c(
        "span",
        {
          staticClass: "text-white mr-2 text-md",
        },
        [_vm._v(_vm._s(_vm.label) + " :")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "text-success text-md text-monospace",
        },
        [
          _vm._v(
            _vm._s(
              _vm.points.toLocaleString("en-US", {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              })
            )
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }